export const GREEN       = '#218333';
export const GREEN_HOVER = '#1a6a28';
export const GREEN_FAINT = 'rgba(33,131,51,0.40)';
export const CHARCOAL    = '#121212';
export const BORDER      = 'rgba(0,0,0,0.12)';
// Darkened for stronger contrast — the previous values (0.46 / 0.28) read as
// washed-out on light backgrounds. These keep the same role (secondary /
// tertiary text) but hold up at small sizes.
export const MUTED       = 'rgba(0,0,0,0.62)';
export const MUTED_FAINT = 'rgba(0,0,0,0.42)';
export const STONE50     = '#fafaf9';
export const GREEN50     = '#f0fdf4';


// ─── Message colours ────────────────────────────────────────────────────────
// One set of colours for every loading, error, warning and success message on
// the site (see src/shared/components/status/). Before this, the site used four
// different reds. ERROR is dark enough to read easily at small sizes.
export const ERROR          = '#B42318';
export const ERROR_BG       = 'rgba(180,35,24,0.06)';
export const ERROR_BORDER   = 'rgba(180,35,24,0.24)';
export const WARNING        = '#854F0B';
export const WARNING_BG     = 'rgba(133,79,11,0.06)';
export const WARNING_BORDER = 'rgba(133,79,11,0.24)';
export const SUCCESS        = GREEN;
export const SUCCESS_BG     = 'rgba(33,131,51,0.05)';
export const SUCCESS_BORDER = 'rgba(33,131,51,0.24)';
export const INFO           = MUTED;
export const INFO_BG        = STONE50;
export const INFO_BORDER    = BORDER;

// App/dashboard surface — replaces the flat warm-grey (#f7f7f5) background.
// Crisp near-white with a faint grid keeps continuity with the marketing
// site's hero/section treatment instead of feeling like a separate, duller app.
export const APP_BG = '#ffffff';
export const appGridBg = {
  backgroundColor: APP_BG,
  backgroundImage: `
    linear-gradient(rgba(0,0,0,0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,0,0,0.035) 1px, transparent 1px)
  `,
  backgroundSize: '32px 32px',
};

export const labelMono = {
  fontFamily:    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize:      '0.7rem',
  fontWeight:    700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
};

export const bodyFont = {
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

// Page side gap — the empty space between the left menu and the start of the
// page content (and the same on the right). Every module uses this so the
// heading and content always start in the same place: 24px on phones, 40px on
// larger screens (matching the top bar above).
export const PAGE_PX = { xs: '24px', md: '40px' };

// Page heading styles — shared by the heading at the top of every module
// (Space Planning, Questionnaire, Moodboard, Materials, Fittings & Furnishings)
// so all five look the same: same size, same green italic ending, and the
// description below always wraps at the same comfortable reading width.
export const pageTitle = {
  ...bodyFont,
  fontSize: 'clamp(1.5rem, 2.5vw, 1.875rem)',
  fontWeight: 300, lineHeight: 1.1, letterSpacing: '-0.03em',
  color: CHARCOAL, mb: 1,
};

export const pageTitleAccent = {
  fontStyle: 'italic', fontWeight: 300, color: GREEN,
};

export const pageDescription = {
  ...bodyFont,
  fontSize: '0.875rem', lineHeight: 1.6, color: 'rgba(0,0,0,0.68)',
  maxWidth: 560,
};
